export default "__VITE_ASSET__e0e553bc__"